<template>
	<div class="page-bottom">
		<div class="page-bottom-content">
			<ul class="menu">
				<li v-for="item in menuItems"><router-link v-bind:to="item.link">{{item.name}}</router-link></li>
			</ul>
			<p class="copyright">©2017 SHOJI KAWAMORI, SATELIGHT / XIAMEN SKYLOONG MEDIA.</span></p>
		</div>
		<div class="page-bottom-bg"></div>
		<div class="page-bottom-bg-2"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			menuItems: global.menuItems
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/PageBottom.vue